import { HB_POPULAR_CACHE } from "@/constants/cacheKey";
import useAppStore from "@/context/store";
import { getGrocery } from "@/services";
import { useMount } from "ahooks";
// 用变量存储，多次执行只需要最快的一次就够了
let isImplement = false;
export default function useSaveListCache() {
  const { listCacheMap, setListCacheMap } = useAppStore((state) => {
    return {
      listCacheMap: state.listCacheMap,
      setListCacheMap: state.setListCacheMap,
    };
  });

  useMount(async () => {
    if (!isImplement) {
      isImplement = true;
      let cache = sessionStorage.getItem(HB_POPULAR_CACHE);
      // 如果状态管理器中没数据，seesionStorage中有则存进去
      if (!listCacheMap && cache) {
        setListCacheMap(cache);
      }
      if (!cache) {
        try {
          const data = await getGrocery("hb-Listed-config");
          let result = JSON.stringify(initData(data?.board_details));
          sessionStorage.setItem(HB_POPULAR_CACHE, result);
          setListCacheMap(result);
        } catch (error) {
          // 如果获取数据失败，则置为fasle，允许重新调用
          isImplement = false;
          throw error;
        }
      }
    }
  });
}
// 处理数据将数据格式转化为map形式
const initData = (list) => {
  let map = {};
  if (!list) return map;
  for (let i = 0; i < list.length; i++) {
    let idArr = list[i].board_ids.split(",");
    idArr.forEach((item) => {
      let key = item.trim();
      if (map[key]) {
        map[key].push(list[i]);
      } else {
        map[key] = [list[i]];
      }
    });
  }
  return map;
};
